import { render } from "./PantryVirtualView.vue?vue&type=template&id=464c4f9c&ts=true"
import script from "./PantryVirtualView.vue?vue&type=script&lang=ts"
export * from "./PantryVirtualView.vue?vue&type=script&lang=ts"

import "./PantryVirtualView.vue?vue&type=style&index=0&id=464c4f9c&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__